import { render, staticRenderFns } from "./BikeReservationEditor.vue?vue&type=template&id=3b589f6d&scoped=true&"
import script from "./BikeReservationEditor.vue?vue&type=script&lang=js&"
export * from "./BikeReservationEditor.vue?vue&type=script&lang=js&"
import style0 from "./BikeReservationEditor.vue?vue&type=style&index=0&id=3b589f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b589f6d",
  null
  
)

export default component.exports